export default class BaseModule {
  getName() {
    return '-noname-';
  }

  getPermission(): string {
    return '';
  }

  getPolicy(): string | undefined {
    return undefined;
  }

  getNavigation() {}

  getRoutes() {}
}
